import { connect } from "react-redux"
import React from "react"
import { push, goBack, replace } from "connected-react-router"
import Ajax from "superagent"
import { parse, stringify } from "query-string"
import { values, intersectionBy, sortBy, debounce, pick } from "lodash"
import { Toast } from "react-weui"
import {getAddress, fetchGeolocation } from "../../AppTools"
import Page from "../components/FixedBarPage.jsx"
import {products, productsByCity} from "../../../../data.json"
import {objectifyPosition} from './transportation'
import {randstr} from '../../../lib/Tools'
import CarPicker2 from './components/CarPicker'
import ShowDestination from './components/ShowDestination'
import ShowRecomendation from './components/ShowRecomendation'
import SearchDestination from "./components/SearchDestination"
import ShowOrigin from "./components/ShowOrigin";
import NotAvailableModal from "./components/NotAvailableModal";
import { isRestaurant, isEntradas, isCompra } from "../tags.js"

import "./TransportationPage.less"
import SearchOrigin from "./components/SearchOrigin";

const categories = [
  // #WARNING hardcoded tag ids D:
  {label: "餐厅", tag: "2sn6dbecc3", predicate: isRestaurant },
  {label: "景点", tag: "80ulgbfn21", predicate: isEntradas },
  {label: "购物", tag: "chzlh8hklq", predicate: isCompra },
]

class TransportationPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      isServiceAvailable: true,
      city: this.props.city,
      term: this.props.term,
      selectRencButt: this.props.selectRencButt,
      customOriginAddress: '',
      customDestinationAddress: '',
      destinationCoords: "",
      geoPermission: "",
      picker_value: '',
      carMode: "NOW",
      ...this.props.formData,
      originCoords: "",
      originAddress: "",
    }
    this.debouncedOriginGeolocation = debounce((dataForGeolocation) => {
      this.getOriginGeolocation(dataForGeolocation)
    }, 1000, {trailing : true})
    this.debouncedDestinationGeolocation = debounce((dataForGeolocation) => {
      this.getDestinationGeolocation(dataForGeolocation)
    }, 1000, {trailing : true})

    // #HACK I'm trying a dirty hack to get around the map sizing issues 1/3
    this.firstRender = true
  }

  componentDidMount() {
    Ajax.get(`/getipinfo`).then(res => {
      this.setState({loading: false})
      if (res.body.country == 'CN') this.setState({isServiceAvailable: false})
      else {
      // this.checkGeoPermission()
        if (this.state.geoPermission != "denied") this.geo()

        const parsed = parse(this.props.location.search)
        if (parsed.zone) this.props.onChange(this.state.city, {destinationZone: parsed.zone})
        if (parsed.place) this.props.onChange(this.state.city, {destinationPlace: parsed.place})

        if (this.state.originCoords && this.state.destinationCoords) {
          this.checkIfRouteIsViable(this.state.originCoords, this.state.destinationCoords)
        }
      }
    })
  }

  componentWillUnmount() {
    navigator.geolocation.clearWatch(this.state.geoId)
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.geoPermission != "granted" && this.state.geoPermission == "granted") this.geo()
  }

  checkGeoPermission() {
    navigator.permissions.query({name:'geolocation'}).then((permissionStatus) => {
      this.setState({geoPermission: permissionStatus.state})
      permissionStatus.onchange = () => this.setState({geoPermission: this.state})
    })
  }

  geo() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Position
    // https://developer.mozilla.org/en-US/docs/Web/API/Coordinates => accuracy in meters
    // https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition
    this.setState({
      fetchingCoords: true,
    })
    const geoId = navigator.geolocation.watchPosition(
      position => {
        if (
          position && this.state.position && this.state.position.coords
          && position.coords.longitude.toFixed(4) === this.state.position.coords.longitude.toFixed(4)
          && position.coords.latitude.toFixed(4) === this.state.position.coords.latitude.toFixed(4)
        ) {
          return
        }

        getAddress(position.coords.latitude, position.coords.longitude)
          .then(result => {
            this.setState({
              fetchingCoords:false,
              city: this.props.city ? this.props.city : result.address_components[2].long_name,
              geoAddress: result.formatted_address,
              originAddress: result.formatted_address,
              googleLocation: result,
              geoCoords: [position.coords.latitude, position.coords.longitude],
              position: objectifyPosition(position),
              originCoords: [position.coords.latitude, position.coords.longitude]
            })
          })
      },
      error => { 
        console.error(`position error: ${JSON.stringify(error)}`) 
        this.setState({fetchingCoords: false})
      },
      { enableHighAccuracy: false, timeout: 60000, maximumAge: 180000}
    )
    this.setState({
      geoId
    })
  }

  checkIfRouteIsViable(originCoords, destinationCoords) {
    this.setState({fetchingUberAvailability: true})
    if (originCoords && destinationCoords) {
      const uberFetchId = randstr()
      this.setState({uberFetchId})
      Ajax
        .post(`/uberapi/getPriceForRouteAsync`)
        .send({uberFetchId, originCoords, destinationCoords})
        .then(res => res.body.uberFetchId == this.state.uberFetchId && this.setState({uberAvailability: res.body.code, fetchingUberAvailability: false}))
    }
  }

  filteredProducts() {
    // #TODO is this working!? is that intersection right? debug this pls
    const intersectionArray = values(products)
    const prByCitys = this.props.city ? productsByCity[this.props.city] : intersectionArray
    const prByTag = this.props.tag ? values(products).filter(prd => prd.tags && prd.tags[this.props.tag]) : intersectionArray
    return intersectionBy(intersectionArray, prByCitys, prByTag, "_id")
  }

  getDestinationGeolocation(dataForGeolocation) {
    if (dataForGeolocation.nextAddress != dataForGeolocation.currentAddress) {
      if (!dataForGeolocation.nextAddress) {
        this.setState({customDestinationCoords: "", destinationCoords: "", uberAvailability: ""})
      }
      else {
        const x = encodeURIComponent(`${dataForGeolocation.nextAddress}`)
        this.setState({searchedAddress : x, fetchingCoords: true})
        if (x) {
          fetchGeolocation(x).then(geolocation => {
            if (x == this.state.searchedAddress) {
              this.setState({
                customDestinationCoords: [geolocation.geometry.location.lat, geolocation.geometry.location.lng],
                destinationCoords: [geolocation.geometry.location.lat, geolocation.geometry.location.lng],
                fetchingCoords: false,
              })
            }
          })
        }
      }
    }
  }

  getOriginGeolocation(dataForGeolocation) {
    if (dataForGeolocation.nextAddress != dataForGeolocation.currentAddress) {
      if (!dataForGeolocation.nextAddress) {
        this.setState({customOriginCoords: "", originCoords: "", uberAvailability: ""})
      }
      else {
        const x = encodeURIComponent(`${dataForGeolocation.nextAddress}`)
        this.setState({searchedAddress : x, fetchingCoords: true})
        if (x) {
          fetchGeolocation(x).then(geolocation => {
            if (x == this.state.searchedAddress) {
              this.setState({
                city: geolocation.address_components[2].long_name,
                customOriginCoords: [geolocation.geometry.location.lat, geolocation.geometry.location.lng],
                originCoords: [geolocation.geometry.location.lat, geolocation.geometry.location.lng],
                originAddress: this.state.searchedAddress,
                fetchingCoords: false
              })
            }
          })
        }
      }
    }
  }

  changeAddress(key, address, method) {
    if (method == "type") {
      const debounceData = {
        nextAddress : address,
        currentAddress : this.state[key],
        currentCity : this.state.city,
      }
      if (key == "customDestinationAddress") this.debouncedDestinationGeolocation(debounceData)
      else if (key == "customOriginAddress") this.debouncedOriginGeolocation(debounceData)
    }
    this.setState({[key]: address })
  }

  changeCoords(oriOrDest, coords, city) {
    const ori = oriOrDest == "origin"
    const method = ori ? this.debouncedOriginGeolocation : this.debouncedDestinationGeolocation
    const key = ori ? "originCoords" : "destinationCoords"
    const keyCustom = ori ? "customOriginCoords" : "customDestinationCoords"

    method.cancel()
    this.setState({
      city,
      [key]: coords,
      [keyCustom]: coords,
    })
    this.props.push(`/catalogo/${this.state.city}/transportation?step=showOrigin`)
  }
  
  getTitle() {
    const { step } = this.props
    if (step == "showCarPicker") return "选择出租⻋"
    else if (step == "showRecomendation") return "流行地点"
    // else return step
    else return "打车服务"
  }

  render() {
    const rankedProducts = sortBy(
      this.filteredProducts(), product => -(product.rank || 0)
    )
    
    // #WARNING #HACK ugly hack. im sorry.
    const selectedCategory = categories
      .find(c => c.tag == (this.state.selectRencButt || this.props.selectRencButt || "2sn6dbecc3"))

    return this.state.loading 
      ? (<Toast icon="loading" show>Loading...</Toast>) 
      : (
        <Page
          title={this.getTitle()}
          pillButton={false}
          containerProps={{
            id: "transportation-page",
          }}
          footerButton={this.props.step == "showCarPicker" || this.props.step == "showOrigin"}
          footerLabel="下一步"
          onFooterClick={() => {
            if (this.props.step == "showOrigin") {
              this.props.push(`/catalogo/${this.state.city}/transportation?step=showCarPicker`)
            }
            else {
              this.props.onChange(
                this.state.city,
                pick(this.state,
                  [ 'originCoords',
                    'originAddress',
                    'destinationCoords',
                    'destinationAddress',
                    'price',
                    'selectedCar',
                    'carsNumber',
                    'carMode',
                    'day',
                    'picker_value'
                  ])
              )
              this.props.push(`/catalogo/${this.state.city}/reservation/formpage/car`)
            }
          }}
          hideBar={this.props.step == "searchDestination" || this.props.step == "searchOrigin"}
          footerDisabled={
            !this.state.originCoords
          || (this.props.step == "showOrigin" && (!this.state.originCoords || !this.state.destinationCoords))
          || (this.props.step == "showCarPicker" && (!this.state.selectedCar || (this.state.carMode == "LATER" && !this.state.day)))
          }
        >
          {
            (this.props.step == "showDestination") && (
              <ShowDestination 
                city={this.props.city}
                originCoords={this.state.originCoords}
                destinationCoords={this.state.destinationCoords}
                fetchingCoords={this.state.fetchingCoords}
                setDestination={destinationData => {
                  this.setState(destinationData)
                }}
                push={url => this.props.push(url)}
              />
            )
          }

          {this.props.step == "showRecomendation" && (
            <ShowRecomendation 
              city={this.props.city}
              categories={categories}
              selectedCategory={selectedCategory}
              rankedProducts={rankedProducts}
              selectRencButt={this.state.selectRencButt || "80ulgbfn21"}
              setDestination={destinationData => {
                this.setState(destinationData)
              }}
              setRencButt={rencButt => {
                this.setState(rencButt)
              }}
              push={url => this.props.push(url)}
            />
          )}

          {this.props.step == "searchDestination" && (
            <SearchDestination 
              city={this.props.city}
              customDestinationAddress={this.state.customDestinationAddress}
              categories={categories}
              push={url => this.props.push(url)}
              goBack={this.props.goBack}
              changeAddress={this.changeAddress.bind(this, "customDestinationAddress")}
              changeCoords={this.changeCoords.bind(this, "destination")}
            />
          )}

          {this.props.step == "showOrigin" && (
            <ShowOrigin 
              city={this.props.city}
              fetchingCoords={this.state.fetchingCoords}
              originAddress={this.state.originAddress}
              originCoords={this.state.originCoords}
              destinationAddress={this.state.destinationAddress}
              destinationCoords={this.state.destinationCoords}
              customDestinationAddress={this.state.customDestinationAddress}
              push={url => this.props.push(url)}
            />
          )}

          {this.props.step == "searchOrigin" && (
            <SearchOrigin 
              city={this.props.city}
              customOriginAddress={this.state.originAddress}
              push={url => this.props.push(url)}
              goBack={this.props.goBack}
              setGeo={() => (this.state.geoAddress && this.state.geoCoords ? this.setState({originAddress: this.state.geoAddress, originCoords: this.state.geoCoords}) : this.geo())
              }
              changeAddress={this.changeAddress.bind(this, "originAddress")}
              changeCoords={this.changeCoords.bind(this, "origin")}
            />

          )}
          {this.props.step == "showCarPicker" && (
            <CarPicker2
              city={this.props.city}
              originCoords={this.state.originCoords}
              destinationCoords={this.state.destinationCoords}
              carMode={this.state.carMode}
              push={url => this.props.push(url)}
              userInfo={this.props.userInfo}
              picker_value={this.state.picker_value}
              carOnChange={(selectedCar, carsNumber, price) => this.setState({selectedCar, carsNumber, price})}
              priceOnChange={price => this.setState({price})}
              onTimeSelected={(day, picker_value) => this.setState({day, picker_value})}
              carModeChange={carMode => this.setState({carMode})}
            />
          )}
          {!this.state.isServiceAvailable && (
            <NotAvailableModal
              onClose={() => this.props.goBack()}
            />
          )}
        </Page>
      )
  }
}

const mapStateToProps = (state, ownProps) => {
  const query = parse(state.router.location.search)

  return {
    step: query.step || "showDestination",
    selectRencButt: query.selectRencButt || "80ulgbfn21",
    formData: state.transportation[ownProps.match.params.city] || {},
    query,
    city: ownProps.match.params.city || "",
    term: query.term || "",
    userInfo: state.userInfo,
  }
}


const mapDispatchToProps = (dispatch, _ownProps) => ({
  onChange: (city, payload) => dispatch({ type: "TRANSPORTATION_FORM", payload : {city, payload}}),
  push: (url) => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  updateSearch: query => dispatch(replace({search: stringify(query)}))
})

export default connect(mapStateToProps, mapDispatchToProps)(TransportationPage)



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/TransportationPage.jsx